export type TimekeepingAction = "clock-in" | "clock-out" | "break-start" | "break-end";

export const TIMEKEEPING_INTEGRATIONS_ACTION_NOT_FOUND_ERROR_MESSAGE =
  "Timekeeping action not found";
export const WORKER_NOT_CLOCKED_OUT_FROM_WORKPLACE_TIMECLOCK_ERROR_MESSAGE =
  "Worker is not clocked out from the workplace time clock yet";

export const DURATION_OF_TIMEKEEPING_ACTION_SUCCESS_MESSAGE_IN_MS = 2.5 * 1000;

// Extended retry configuration for timekeeping integrations
// Phase 1: Quick retry - 30 seconds total, every 3 seconds
export const QUICK_RETRY_INTERVAL_MS = 3 * 1000;
export const QUICK_RETRY_DURATION_MS = 30 * 1000;

// Phase 2: Extended retry - up to 5 minutes total, every 5 seconds
export const EXTENDED_RETRY_INTERVAL_MS = 5 * 1000;
export const EXTENDED_RETRY_DURATION_MS = 5 * 60 * 1000;

// Network error retry configuration for timekeeping actions (bad connectivity)
export const TIMEKEEPING_NETWORK_RETRY_MAX_ATTEMPTS = 3;
export const TIMEKEEPING_NETWORK_RETRY_BASE_DELAY_MS = 1_000;
export const TIMEKEEPING_NETWORK_RETRY_MAX_DELAY_MS = 10_000;
